import React from "react";
import { useGetGoogleMeetLinkQuery } from "../../../Service/appoinment";

const SuccessPage = () => {
  const url = window.location.href;
  console.log(url, "url");
  const urlParams = new URL(url).searchParams;
  const codeValue = urlParams.get("code");

  const {
    data: linkData,
    refetch,
    isLoading,
    isSuccess,
    isError
  } = useGetGoogleMeetLinkQuery(codeValue, {
    refetchOnMountOrArgChange: true,
  });

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "70vh" }}
      >
        <div>Loading...</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "70vh" }}
      >
        <div
          className="card text-center shadow-sm"
          style={{ width: "24rem", borderRadius: "10px" }}
        >
          <div className="card-body">
            <div className="mb-3">
              <i
                className="bi bi-x-circle-fill text-danger"
                style={{ fontSize: "2.5rem" }}
              ></i>
            </div>
            <h5 className="card-title mb-3" style={{ color: "#d9534f" }}>
              Error
            </h5>
            <p className="card-text">
              Something went wrong. Please try again later.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (isSuccess) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "70vh" }}
      >
        <div
          className="card text-center shadow-sm"
          style={{ width: "24rem", borderRadius: "10px" }}
        >
          <div className="card-body">
            <div className="mb-3">
              <i
                className="bi bi-check-circle-fill text-success"
                style={{ fontSize: "2.5rem" }}
              ></i>
            </div>
            <h5 className="card-title mb-3" style={{ color: "#6842d9" }}>
              Message Sent
            </h5>
            <p className="card-text">
              The meeting link has been sent to WhatsApp.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "70vh" }}
    >
      <div>Something went wrong. Please refresh the page.</div>
    </div>
  );
};

export default SuccessPage;
